export const iconFontAwesomeSpinnersGear = (
	<i className="fa-solid fa-gear"></i>
);
